import { Like } from './like';
import { ShowServerData } from './show';
import { User } from './user';

export const enum ParticipantStatus {
  Muted = 'muted',
  ForceMuted = 'forceMuted',
  Unmuted = 'unmuted',
  Left = 'left',
  NotHosting = 'notHosting',
  Pending = 'pending',
}

export const enum ParticipantRole {
  Host = 'host',
  CoHost = 'coHost',
  Listener = 'listener',
  Speaker = 'speaker',
}

export const enum TeamType {
  Blue = 'blue',
  Red = 'red',
  Neutral = 'neutral',
}

export const enum ParticipantPosition {
  Left = 'left',
  Right = 'right',
}

type ParticipantBase = {
  id: string;
  uid: number;
  status: ParticipantStatus;
  role: ParticipantRole;
  team: TeamType | null;
};

export type Participant = {
  profileId: string;
  showId: string;
} & ParticipantBase;

export type ParticipantServerData = {
  profile: User;
  show: ShowServerData;
} & ParticipantBase;

export type Speaker = {
  id: string;
  profileId: string;
  topicId: string;
  side: TeamType;
  likesCount: number;
  participantId?: string;
  createdAt?: Date;
  endedAt?: Date;
};

export type SpeakerServerData = {
  id: string;
  side: TeamType;
  user: { id: string };
  topic: { id: string };
  participant?: { id: string };
  likes: Like[];
  createdAt: Date;
  endedAt: Date;
};

export type UpdateParticipantRoleSocketData = {
  id: string;
  role: ParticipantRole;
  team: TeamType;
  uid: number;
  status: ParticipantStatus;
  requestId: string;
  profile: User;
  speaker: SpeakerServerData;
};
